module.exports = __webpack_public_path__ + "static/media/image_2.9542af07.svg";